import { GzOverviewWebComponent } from './component/OverviewWebComponent';

export { GzOverviewWebComponent };
